/**
 * Runtime error types. A thrown `TypeError` (`Cannot read properties of undefined...`),
 * `ReferenceError`, etc. is always a bug in our own code -- never a message written for
 * a user -- so it must never reach the screen.
 */
const RUNTIME_ERRORS = [TypeError, ReferenceError, RangeError, SyntaxError, URIError, EvalError];

const isRuntimeError = (error: unknown) => RUNTIME_ERRORS.some((kind) => error instanceof kind);

/**
 * The message to render for a caught error.
 *
 * Actions author their user-facing text with `new Error(...)` (see `apiErrorMessage` in
 * `store/session/actions`), and that text is passed through. Anything else -- a runtime
 * error that escaped a handler, a rejected non-Error value, an empty message -- is logged
 * and replaced by `fallback`, so a bug shows up in the console instead of in the UI.
 */
export const messageForUser = (error: unknown, fallback: string): string => {
    if (error instanceof Error && !isRuntimeError(error) && error.message) return error.message;

    console.error(error); // eslint-disable-line no-console
    return fallback;
};
